import _ from 'underscore';
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Animation from 'components/Animation';
import Button from 'components/Button';
import Search from 'components/Search';

import styles from './styles.module.scss';

const SearchButton = ({ onClick, onRequestClose, tabIndex }) => {
	const [search, setSearch] = useState(false);
	const buttonSearchRef = useRef(null);

	const onChange = useCallback((string) => {
		window.location.href = `/search?query=${string}`;
	}, []);

	const toggleSearch = useCallback(() => {
		setSearch(!search);
	}, [search]);

	return (
		<>
			<Button
				tooltip="Поиск"
				icon="search"
				theme="onlyIcon"
				onClick={toggleSearch}
				tabIndex={tabIndex}
				className={styles.SearchButton}
				buttonRef={buttonSearchRef}
				ariaLabel="Поиск"
			/>
			<Animation show={search} onEntering={onClick} onExiting={onRequestClose}>
				<Search
					onChange={onChange}
					onRequestClose={toggleSearch}
					tabIndex={search ? 0 : -1}
				/>
			</Animation>
		</>
	);
};

SearchButton.propTypes = {
	onRequestClose: PropTypes.func,
	onClick: PropTypes.func,
	tabIndex: PropTypes.number
};

SearchButton.defaultProps = {
	onRequestClose: _.noop,
	onClick: _.noop
};

export default SearchButton;
